export default "__VITE_ASSET__DtSaP52w__"